import DashboardIcon from "@mui/icons-material/Dashboard";
import BookOnlineIcon from "@mui/icons-material/BookOnline";
import PeopleIcon from "@mui/icons-material/People";
import NotificationsIcon from "@mui/icons-material/Notifications";
import BarChartIcon from "@mui/icons-material/BarChart";
import PaymentIcon from "@mui/icons-material/Payment";

import { MENU_STRINGS } from "./strings";
import { MenuGroupType } from "../types/layout"; // ✅ FIXED

export const MENU_GROUPS: MenuGroupType[] = [
  {
    items: [
      {
        label: MENU_STRINGS.DASHBOARD,
        path: "/dashboard",
        icon: DashboardIcon,
      },
      {
        label: MENU_STRINGS.PROVIDERS,
        path: "/provider",
        icon: BookOnlineIcon,
      },
      {
        label: MENU_STRINGS.USERS,
        path: "/users",
        icon: PeopleIcon,
      },
    ],
  },
  {
    title: "Management",
    items: [
      {
        label: MENU_STRINGS.NOTIFICATIONS,
        path: "/notifications",
        icon: NotificationsIcon,
      },
      {
        label: MENU_STRINGS.REPORTS,
        path: "/reports",
        icon: BarChartIcon,
      },
      {
        label: MENU_STRINGS.PAYMENTS,
        path: "/payments",
        icon: PaymentIcon,
      },
    ],
  },
];